import React from 'react';
import { Card, Text, Grid } from '@/theme/index';

interface ContactHeaderProps {
  cardBackgroundColor: string;
  textWidth: string | number;
  gridSpacing: number;
}

/**
 * This component is responsible for displaying the header of the table from related contacts section.
 */
export function ContactHeader({
  cardBackgroundColor,
  textWidth,
  gridSpacing,
}: ContactHeaderProps) {
  return (
    <Card
      sx={(theme) => ({
        width: '100%',
        height: '44px',
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(2),
        borderRadius: 0,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: cardBackgroundColor,
        color: theme.palette.primary.contrastText,
      })}
    >
      <Text
        fontWeight={700}
        width={textWidth}
        marginRight={13.5}
        marginLeft={1}
      >
        Name & Title
      </Text>
      <Grid container alignItems="center" spacing={gridSpacing}>
        <Grid item>
          <Text fontWeight={700}>Company</Text>
        </Grid>
        <Grid item>
          <Text fontWeight={700}>Location</Text>
        </Grid>
      </Grid>
    </Card>
  );
}
